module.exports = __webpack_public_path__ + "ac8ebf3b2328cb84b94c54e98e6fb9f4.svg";